module.exports = __webpack_public_path__ + "static/media/monri_logo.6561f2b0.jpg";